import { CardBenefitsComponentsHero } from './hero'
import { CardBenefitsComponentsTerms } from './terms'
import { CardBenefitsComponentsTitle } from './title'
import { CardBenefitsComponentsSummary } from './summary'
import { CardBenefitsComponentsContainer } from './container'
import { CardBenefitsComponentsHeader } from './header'
import { CardBenefitsComponentsScroll } from './scroll'
import { CardBenefitsComponentsHowToRedeem } from './how-to-redeem'
import { CardBenefitsComponentsNonMesaMemberModal } from './non-mesa-member-modal'
import { CardBenefitsComponentsEnrollmentSuccessModal } from './enrollment-success-modal'
import { CardBenefitsComponentPoint } from './point'
import { CardBenefitsComponentsLearnMoreModal } from './learn-more-modal'
import { BenefitRedemptionProgress } from './BenefitRedemptionProgress'
import { CardBenefitsComponentsOfferIsNowFull } from './offer-is-now-full'
import { LowesHowToRedeem } from './LowesHowToRedeem'
import { BenefitCard } from './BenefitCard'

export const CardBenefitsComponents = {
  Container: CardBenefitsComponentsContainer,
  Header: CardBenefitsComponentsHeader,
  Scroll: CardBenefitsComponentsScroll,
  Hero: CardBenefitsComponentsHero,
  Title: CardBenefitsComponentsTitle,
  Summary: CardBenefitsComponentsSummary,
  HowToRedeem: CardBenefitsComponentsHowToRedeem,
  Terms: CardBenefitsComponentsTerms,
  NonMesaMemberModal: CardBenefitsComponentsNonMesaMemberModal,
  EnrollmentSuccessModal: CardBenefitsComponentsEnrollmentSuccessModal,
  LearnMoreModal: CardBenefitsComponentsLearnMoreModal,
  Point: CardBenefitsComponentPoint,
  RedemptionProgress: BenefitRedemptionProgress,
  OfferIsNowFull: CardBenefitsComponentsOfferIsNowFull,
  LowesHowToRedeem,
  BenefitCard,
}
